/* eslint-disable consistent-return */
/* eslint-disable no-console */
/* eslint-disable camelcase */
import uuid from 'uuid/v4'
import axios, { csrfToken } from 'CanExConfig/axios'

export const createCandidate = async (candidate, recaptchaToken) => {
  const response = await axios('/candidate/signup/create', {
    method: 'post',
    data: {
      candidate,
      'g-recaptcha-response-data': {
        zadev: recaptchaToken,
      },
    },
  })

  return response
}

export const updateCandidate = async candidate => {
  const response = await axios('/candidate/signup/update_profile', {
    method: 'post',
    data: {
      candidate: {
        ...candidate,
      },
    },
  })

  return response.data
}

export const completeOnboarding = async () => {
  const response = await axios('/candidate/completed', {
    method: 'patch',
  })

  return response.data
}

export const confirmDetailsCandidate = async candidate => {
  const response = await axios('/users/confirm_details', {
    method: 'post',
    data: {
      candidate: {
        ...candidate,
      },
    },
  })

  return response.data
}

export const uploadFile = async file => {
  try {
    const data = new FormData()
    data.append('uploaded_file[file]', file)
    data.append('authenticity_token', csrfToken)

    const response = await axios.post('/candidate/signup/upload_file', data, {
      onUploadProgress: event => {
        if (!event.lengthComputable) return console.log(Math.round((event.loaded * 100) / event.total))
      },
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      },
    })

    return response.data
  } catch (error) {
    console.log('Error error: ', error)
  }
}

export const removeFile = async id => {
  const response = await axios('/candidate/signup/remove_file', {
    method: 'delete',
    data: {
      file_id: id,
    },
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
    },
  })

  return response.data
}

const normalisePlaces = places => {
  return places.map(place => ({
    id: uuid(),
    name: place.comprehensive_location.inputted_address,
    based_in_location: {
      ...place.comprehensive_location,
      comprehensive_location_category: 'based_in',
    },
  }))
}

export const fetchPlaces = async term => {
  const response = await axios.get(`/search/comprehensive_locations/?term=${encodeURIComponent(term)}&limit=5`)
  return normalisePlaces(response.data)
}

export const searchCompanies = async term => {
  const response = await axios('/search/companies', {
    method: 'GET',
    params: {
      term,
    },
  })
  return response.data
}

export const searchUniversities = async term => {
  const response = await axios('/search/universities', {
    method: 'GET',
    params: {
      term,
    },
  })
  return response.data
}

export const searchDegrees = async term => {
  const response = await axios('/search/degrees', {
    method: 'GET',
    params: {
      term,
    },
  })
  return response.data
}

export const searchCandidateRoles = async term => {
  const response = await axios('/search/roles', {
    method: 'GET',
    params: {
      term,
    },
  })
  return response.data
}

const workHistoriesEndpoint = candidateProfileId => `/api/candidate/v2/candidate_profiles/${candidateProfileId}/work_histories`
const workHistoryEndpoint = workHistoryId => `/api/candidate/v2/work_histories/${workHistoryId}`

export const fetchWorkHistory = async id => {
  const response = await axios.get(workHistoriesEndpoint(id))
  return response.data.result
}

export const updateWorkHistory = async (id, data) => {
  const response = await axios(workHistoryEndpoint(id), {
    method: 'PATCH',
    data,
  })

  return response.data.result
}

export const createWorkHistory = async (id, data) => {
  const response = await axios(workHistoriesEndpoint(id), {
    method: 'POST',
    data,
  })

  return response.data.result
}

export const deleteWorkHistory = async id => {
  const response = await axios(workHistoryEndpoint(id), {
    method: 'DELETE',
  })

  return response.data.result
}

const educationsEndpoint = candidateProfileId => `/api/candidate/v2/candidate_profiles/${candidateProfileId}/educations`
const educationEndpoint = educationId => `/api/candidate/v2/educations/${educationId}`

export const fetchEducation = async id => {
  const response = await axios.get(educationsEndpoint(id))
  return response.data.result
}

export const updateEducation = async (id, data) => {
  const response = await axios(educationEndpoint(id), {
    method: 'PATCH',
    data,
  })

  return response.data.result
}

export const createEducation = async (id, data) => {
  const response = await axios(educationsEndpoint(id), {
    method: 'POST',
    data,
  })

  return response.data.result
}

export const deleteEducation = async id => {
  const response = await axios(educationEndpoint(id), {
    method: 'DELETE',
  })

  return response.data.result
}

const skillsEndpoint = candidateProfileId => `/api/candidate/v2/candidate_profiles/${candidateProfileId}/skills`

export const searchSkills = async term => {
  const response = await axios.get(`/search/skills?term=${term}`)
  return response.data
}

export const fetchSkills = async id => {
  const response = await axios(skillsEndpoint(id), {
    method: 'GET',
  })

  return response.data.result
}

export const updateSkills = async (id, data) => {
  const response = await axios(skillsEndpoint(id), {
    method: 'PATCH',
    data: {
      skills: data,
    },
  })

  return response.data.result
}

/*
 ** Job Experiences API
 */

const candidateJobExperiencesEndpoint = candidateId => `/api/candidate/v2/candidate_profiles/${candidateId}/job_experiences`

export const createJobExperience = async (id, data) => {
  const response = await axios(candidateJobExperiencesEndpoint(id), {
    method: 'POST',
    data,
  })

  return response.data.result
}

export const fetchJobExperiences = async id => {
  const response = await axios(candidateJobExperiencesEndpoint(id), {
    method: 'GET',
  })

  return response.data.result
}

const jobExperiencesEndpoint = jobExperienceId => `/api/candidate/v2/job_experiences/${jobExperienceId}`

export const updateJobExperience = async data => {
  const response = await axios(jobExperiencesEndpoint(data.id), {
    method: 'PATCH',
    data,
  })

  return response.data.result
}

export const deleteJobExperience = async id => {
  const response = await axios(jobExperiencesEndpoint(id), {
    method: 'DELETE',
  })

  return response.data.result
}
